<template>
  <b-container class="bg-light pb-3">
    <b-row>
      <b-col class="text-left pt-3 pl-3 text-muted">
        <small><font-awesome-icon :icon="['fas', 'chevron-left']" class="mr-1"></font-awesome-icon>{{ this.directionShort(Number(heading - 45)) }}</small>
      </b-col>
      <b-col cols="6" class="text-center p-2" style="background-color: #d1ecf1;">
        <div style="line-height: 1.2;">
          <font-awesome-icon :icon="['fas', 'angle-right']" class="text-primary mr-1"></font-awesome-icon><strong>{{ heading }}</strong>&deg;<font-awesome-icon :icon="['fas', 'angle-left']" class="text-primary ml-1"></font-awesome-icon>
        </div>
        <div class="heading-subtext">
          {{ this.direction(heading) }}
        </div>
      </b-col>
      <b-col class="text-right pt-3 pr-3 text-muted">
        <small>{{ this.directionShort(Number(heading + 45)) }}<font-awesome-icon :icon="['fas', 'chevron-right']" class="ml-1"></font-awesome-icon></small>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-embed class="" type="iframe" aspect="16by9"
                 src="https://www.youtube.com/embed/live_stream?channel=UCb5NVjj55DLXB_pTtvRgaPg&controls=1&autoplay=0&showinfo=0&rel=0&modestbranding=1&fs=1&mute=1" allow="autoplay" allowfullscreen />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { mapGetters } from 'vuex'
import Helpers from '@/mixins/helpers'

/**
 * Constant defining the time delay allowed for data to be displayed
 * @type {number} [ms]
 */
const UPDATE_TIMEOUT_MS = 60 * 60 * 1000000000

export default {
  name: 'ShipDagmarAaenLivestreamWidget',
  props: ['platformId'],
  mixins: [
    Helpers
  ],
  methods: {
    created: function () {},
    mounted: function () {},
    beforeDestroy: function () {},
    direction: function (h) {
      const heading = (h + 360) % 360
      if (heading >= 22.5 && heading < 67.5) {
        return 'North-East'
      } else if (heading >= 67.5 && heading < 112.5) {
        return 'East'
      } else if (heading >= 112.5 && heading < 157.5) {
        return 'South-East'
      } else if (heading >= 157.5 && heading < 202.5) {
        return 'South'
      } else if (heading >= 202.5 && heading < 247.5) {
        return 'South-West'
      } else if (heading >= 247.5 && heading < 292.5) {
        return 'West'
      } else if (heading >= 292.5 && heading < 337.5) {
        return 'North-West'
      } else if ((heading >= 337.5 && heading <= 360) || (heading >= 0 && heading < 22.5)) {
        return 'North'
      }
      return ''
    },
    directionShort: function (h) {
      const heading = (h + 360) % 360
      if (heading >= 22.5 && heading < 67.5) {
        return 'NE'
      } else if (heading >= 67.5 && heading < 112.5) {
        return 'E'
      } else if (heading >= 112.5 && heading < 157.5) {
        return 'SE'
      } else if (heading >= 157.5 && heading < 202.5) {
        return 'S'
      } else if (heading >= 202.5 && heading < 247.5) {
        return 'SW'
      } else if (heading >= 247.5 && heading < 292.5) {
        return 'W'
      } else if (heading >= 292.5 && heading < 337.5) {
        return 'NW'
      } else if ((heading >= 337.5 && heading <= 360) || (heading >= 0 && heading < 22.5)) {
        return 'N'
      }
      return ''
    }
  },
  computed: {
    ...mapGetters(['currentUpdate', 'lastUpdate', 'parameter']),
    recentUpdate () {
      return (entityId, parameterId) => {
        const update = this.currentUpdate(this.platformId, entityId, parameterId)
        const parameter = this.parameter(this.platformId, entityId, parameterId)
        return ((update.length !== 0) && (this.updateAgeValid(update, parameter, UPDATE_TIMEOUT_MS))) ? Number(update[1]) : null
      }
    },
    heading () {
      return this.recentUpdate(1, 3)
    }
  }
}

</script>

<style scoped>

.heading-subtext {
  font-style: italic;
  font-size: 13px;
  line-height: 1.0;
}

</style>
